import React from 'react'
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import { useNavigate } from 'react-router-dom';

const StatusComp = ({ name, type, hide }) => {
    const formmatedType = type ? type.charAt(0).toUpperCase() + type.slice(1) : ''
    const navigate = useNavigate()

    return (
        <div className='col-md-6 py-3 d-flex ac-js gap-2 '>
            {!hide && (<ArrowCircleLeftIcon style={{
                width: '35px', height: '35px', marginBottom: '15px'
            }}
                onClick={() => navigate(-1)}
            />)}


            <p className='f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20  black'>{name} {formmatedType}</p>
        </div>
    )
}

export default StatusComp
